<template>
  <div>
    <h2>美容師搜尋</h2>
  </div>
  <div class="container">
    <ModalCom1 :spa="commSpa" :name="commName"></ModalCom1>
    <label style="color: blue">點開下方搜尋條件，依條件搜尋</label>
    <div>
      <a
        class="btn btn-outline-primary"
        data-bs-toggle="collapse"
        href="#collapseExample"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        搜尋條件
      </a>
    </div>
    <br />
    <div class="collapse" id="collapseExample" style="text-align: left">
      <div class="form-floating">
        <input class="form-control" id="floatingName" placeholder="姓名" v-model="name" />
        <label for="floatingName">姓名</label>
      </div>
      <br />
      <div>
        台費:&emsp;<input
          type="number"
          min="2000"
          step="100"
          style="width: 100px"
          v-model="priceS"
        />~<input
          type="number"
          min="2000"
          step="100"
          style="width: 100px"
          v-model="priceM"
        />
      </div>
      <br />
      <div>
        身高:&emsp;<input type="number" style="width: 100px" v-model="heightS" />~<input
          type="number"
          style="width: 100px"
          v-model="heightM"
        />
      </div>
      <br />
      <div>
        體重:&emsp;<input type="number" style="width: 100px" v-model="weightS" />~<input
          type="number"
          style="width: 100px"
          v-model="weightM"
        />
      </div>
      <br />
      <div>
        罩杯:&emsp;<input
          type="text"
          maxlength="1"
          size="2"
          v-model="cupS"
          oninput="this.value = this.value.toUpperCase()"
        />~<input
          maxlength="1"
          size="2"
          v-model="cupM"
          oninput="this.value = this.value.toUpperCase()"
        />
      </div>
      <br />
      <div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox1"
            v-model="hot"
          />
          <label class="form-check-label" for="inlineCheckbox1">熱門</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox2"
            v-model="isNew"
          />
          <label class="form-check-label" for="inlineCheckbox2">新進</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox3"
            v-model="music"
          />
          <label class="form-check-label" for="inlineCheckbox3">送音樂</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox4"
            v-model="bento"
          />
          <label class="form-check-label" for="inlineCheckbox4">套餐</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="inlineCheckbox5"
            v-model="comm"
          />
          <label class="form-check-label" for="inlineCheckbox5">心得</label>
        </div>
      </div>
      <br />
      <div>
        <a
          class="btn btn-outline-success"
          data-bs-toggle="collapse"
          href="#collapseExample1"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample1"
        >
          店家
        </a>
        &emsp;<label style="color: red">未選預設為全部</label>
      </div>
      <div class="collapse" id="collapseExample1" style="text-align: left">
        <div class="form-check form-check-inline" v-for="spa in spaList" :key="spa.id">
          <input class="form-check-input" type="checkbox" v-model="spa.value" />
          <label class="form-check-label">{{ spa.name }}</label>
        </div>
      </div>
      <br />
      <div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" v-model="today" />
          <label class="form-check-label">只搜尋當日美容師</label>
        </div>
      </div>
      <div style="text-align: center">
        <button type="button" class="btn btn-outline-primary" @click="doSearch()">
          搜尋
        </button>
      </div>
    </div>
  </div>
  <br />
  <div class="container" v-viewer="{ movable: false }">
    <label style="color: red">點圖可放大，表格可往右滑</label>
    <viewer>
      <!-- 表格直接加入 v-loading 遮罩 -->
      <el-table
        v-loading="dataLoading"
        element-loading-text="查詢中..."
        element-loading-background="rgba(255, 255, 255, 0.7)"
        empty-text=" "
        :data="tableItem"
        border
        style="width: 100%"
        header-cell-class-name="my-header"
        :height="tableHeight"
        :cell-style="tableRowStyle"
      >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :fixed="column.fixed"
          :sortable="column.sortable"
        >
          <template #default="scope">
            <img :src="scope.row[column.prop]" v-if="column.show" style="width: 100%" />
            <span v-html="scope.row[column.prop]" v-else-if="column.html" />
            <template v-else-if="column.prop === 'name'">
              <span v-html="format1(scope)" />
              <span>{{ scope.row.name }}</span>
              <br v-if="scope.row.commCount > 0" />
              <button
                v-if="scope.row.commCount > 0"
                type="button"
                class="btn btn-outline-primary btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                @click="doButton(scope.row.spa_id, scope.row.name)"
              >
                心得{{ scope.row.commCount }}
              </button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </viewer>
  </div>
</template>

<script>
import axios from "axios";
import ModalCom1 from "@/components/ModalCom1.vue";

export default {
  components: {
    ModalCom1,
  },
  data() {
    return {
      tableUrl: "/php/spa_table.php",
      configUrl: "/php/spa_config.php",
      name: "",
      priceS: "",
      priceM: "",
      heightS: "",
      heightM: "",
      weightS: "",
      weightM: "",
      cupS: "",
      cupM: "",
      hot: "",
      isNew: "",
      music: "",
      bento: "",
      comm: "",
      today: false,
      dataLoading: false,
      spaConfig: [],
      spaList: [
        { id: "spa_01", name: "含香", value: false },
        { id: "spa_02", name: "爵仕堡", value: false },
      ],
      columns: [],
      tableItem: [],
      tableHeight: 500,
      commSpa: "",
      commName: "",
    };
  },
  methods: {
    async selectAll() {
      try {
        const res = await axios.post(this.configUrl, {
          action: "selectSearchSpa",
        });
        this.spaConfig = res.data || [];
        this.spaList = this.spaConfig.map((item) => ({
          id: item.id,
          name: item.name,
          value: false,
        }));
      } catch (error) {
        console.error("取得 SPA 設定失敗:", error);
      }
    },

    tableRowStyle({ row }) {
      return {};
    },

    format1(scope) {
      if (1 == scope.cellIndex && "true" == scope.row.day_push) {
        return '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"><br>';
      }
      if (1 == scope.cellIndex && "true" == scope.row.is_new) {
        return '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"><br>';
      }
      return "";
    },

    async doSearch() {
      // 點擊搜尋時立即收合選單
      const myCollapse = document.getElementById("collapseExample");
      if (myCollapse) {
        myCollapse.classList.remove("show");
      }

      this.dataLoading = true;
      this.tableItem = [];

      var searchSql = "";
      var flag = new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
      );
      this.name = this.name.trim();

      if (this.name.length !== 0 && !flag.test(this.name)) {
        if (this.name.length > 1) {
          searchSql +=
            " and (name like '%" +
            this.name +
            "%' or REPLACE(name_his, '潘朵拉', '') like '%" +
            this.name +
            "%') ";
        } else {
          searchSql += " and name like '%" + this.name + "%' ";
        }
      }

      if (this.priceS) searchSql += " and price >= '" + this.priceS + "' ";
      if (this.priceM) searchSql += " and price <= '" + this.priceM + "' ";
      if (this.heightS) searchSql += " and height >= '" + this.heightS + "' ";
      if (this.heightM) searchSql += " and height <= '" + this.heightM + "' ";
      if (this.weightS) searchSql += " and weight >= '" + this.weightS + "' ";
      if (this.weightM) searchSql += " and weight <= '" + this.weightM + "' ";
      if (this.cupS) searchSql += " and cup >= '" + this.cupS + "' ";
      if (this.cupM) searchSql += " and cup <= '" + this.cupM + "' ";
      if (this.hot) searchSql += " and day_push = 'true' ";
      if (this.isNew) searchSql += " and is_new = 'true' ";
      if (this.today) searchSql += " and work_time IS NOT NULL ";
      if (this.music) searchSql += " and music = 'true' ";
      if (this.bento) searchSql += " and bento IS NOT NULL and bento <> '' ";
      if (this.comm) searchSql += " and commCount > 0 ";

      var tempSpaList = this.spaList.filter((spa) => spa.value);
      if (tempSpaList.length === 0) {
        tempSpaList = this.spaList;
      }

      try {
        // 順序同步查詢：確保上一個 Spa 查完後再查下一個
        for (const tempSpa of tempSpaList) {
          await this.selectSpa(tempSpa.id, searchSql);
        }
      } catch (error) {
        console.error("搜尋過程出錯:", error);
      } finally {
        this.dataLoading = false;
      }
    },

    async selectSpa(spaId, searchSql) {
      try {
        const res = await axios.post(this.tableUrl, {
          action: "search",
          table_name: spaId,
          searchSql: searchSql,
        });

        if (Array.isArray(res.data) && res.data.length > 0) {
          const findSpaName = this.spaConfig.find((e) => e.id === spaId);
          const spaNameStr = findSpaName ? findSpaName.name : "";

          for (const item of res.data) {
            item.image = "https://imgf.gg9453.com/images/spa_daily/" + item.image;
            item.spa_name = spaNameStr;

            let ex = "";
            if (item.music === "true") ex += "、送音樂";
            if (item.bento) ex += "、套餐" + item.bento;
            ex = ex.startsWith("、") ? ex.substring(1) : ex;
            item.ex = ex;
            item.spa_id = spaId;

            if (item.name_his) {
              item.info = item.info + "<br>" + item.name_his;
            }

            let week = "";
            if (item.w1) week += "一" + item.w1 + "<br>";
            if (item.w2) week += "二" + item.w2 + "<br>";
            if (item.w3) week += "三" + item.w3 + "<br>";
            if (item.w4) week += "四" + item.w4 + "<br>";
            if (item.w5) week += "五" + item.w5 + "<br>";
            if (item.w6) week += "六" + item.w6 + "<br>";
            if (item.w7) week += "日" + item.w7 + "<br>";
            item.week = week;

            this.tableItem.push(item);
          }
        }
      } catch (error) {
        console.error(`查詢 Spa [${spaId}] 失敗:`, error);
      }
    },

    doButton(spa1, name1) {
      this.commSpa = spa1;
      this.commName = name1;
    },

    initColumns() {
      if (window.innerWidth < 600) {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "85px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "120px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          {
            prop: "spa_name",
            label: "店家",
            show: false,
            sortable: true,
            width: "80px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "300px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      } else {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "120px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "200px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
          {
            prop: "spa_name",
            label: "店家",
            show: false,
            sortable: true,
            width: "90px",
          },
          { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "270px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      }
    },
  },
  created() {
    this.selectAll();
    this.tableHeight = Math.max(window.innerHeight - 300, 500);
    this.initColumns();
  },
};
</script>

<style>
.form-check label {
  margin-left: 4px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 500;
}
.form-check .form-check-input[type="checkbox"] {
  border-radius: 0.25em;
  height: 25px;
  width: 25px;
}

.my-header {
  background: black !important;
  border-color: black !important;
  font-size: 16px;
  color: white;
}

.el-table__body-wrapper {
  z-index: 2;
}

.el-table__fixed,
.el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed,
.el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: "";
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  }
}

.el-table .cell {
  font-size: 18px;
  white-space: pre-line;
  overflow: unset;
}
</style>
